import { render, staticRenderFns } from "./CompleteWithdrawal.vue?vue&type=template&id=58fbcb0d&scoped=true&"
import script from "./CompleteWithdrawal.vue?vue&type=script&lang=js&"
export * from "./CompleteWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fbcb0d",
  null
  
)

export default component.exports